import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Deposito } from "@/shared/types/deposito";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteDeposito(id: string): Promise<Deposito> {
    await sleep(1000);
    const response = await api.delete("depositos/" + id);
    return response.data;
}

export function useDeleteDepositoMutation(id: string, mutationConfig: MutationConfig<Deposito> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteDeposito(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["depositos"] });
        },
    })
}

export interface DeleteDepositoMutationProps {
    id: string,
    mutationConfig?: MutationConfig<Deposito>,
    children?: (mutationResult: MutationResult<Deposito>) => ReactNode
}

export function DeleteDepositoMutation({
    id,
    children,
    mutationConfig
}: DeleteDepositoMutationProps) {
    const mutationResult = useDeleteDepositoMutation(id, mutationConfig);
    return children && children(mutationResult)
}
